import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/auth", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        if (r.data?.token) localStorage.setItem("vw_token", r.data.token);
        setUser(r.data.user);
        toast.success(`Welcome, ${r.data.user.name || r.data.user.email}`);
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        toast.error("Sign-in failed");
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="container py-32 text-center" data-testid="auth-callback-loading">
      <div className="inline-block h-10 w-10 rounded-full border-2 border-primary border-r-transparent animate-spin" />
      <p className="mt-6 text-muted-foreground">Securing your session…</p>
    </div>
  );
}
